import resolvePathname from 'resolve-pathname';

import * as projects from '../services/app';
import * as authentication from '../services/authentication';
import { ActionTypes } from '../types/action-types';
import history from '../utils/history';

export const login = (email: string, password: string) => async dispatch => {
    const sessionId = await authentication.login(email, password)
    if (sessionId) {
        const projs = await Promise.all([
            projects.getProjects(sessionId),
            projects.getConsentedProjects(sessionId),
        ])
        dispatch({
            type: ActionTypes.PROFILE_PROJECTS_LOADED,
            projects: projs[0],
        });
        dispatch({
            type: ActionTypes.PROFILE_CONSENTED_PROJECTS_LOADED,
            consentedProjects: projs[1],
        });
        dispatch({
            type: ActionTypes.USER_LOGIN_SUCCESS,
            session: sessionId
        })
        const location = resolvePathname('confirm', history.location.pathname);
        history.push(location);
    } else {
        dispatch({
            type: ActionTypes.USER_LOGIN_FAILURE,
        })
    }
};




// WEBPACK FOOTER //
// ./src/actions/authentication.ts